import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import HttpClient from '../utils/HttpClient';
import './managefaqform.css';

const ManageFaqForm = () => {
    const [ques, setQues] = useState("");
    const [ans, setAns] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState("");
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state && location.state.item) {
            const { question, answer, _id } = location.state.item;
            setQues(question);
            setAns(answer);
            setEditId(_id);
            setIsEdit(location.state.isEdit || false);
        }
    }, [location]);

    const handleBackClick = () => {
        navigate(-1);
    };

    const validate = () => {
        if (!ques) {
            toast.error("Please enter a question");
            return true;
        }
        if (!ans) {
            toast.error("Please enter an answer");
            return true;
        }
        return false;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            return;
        }
        const data = {
            question: ques,
            answer: ans
        };

        let res;
        if (isEdit) {
            res = await HttpClient.requestData(`faq/${editId}`, "PUT", data);
            if (res && res?.status) {
                toast.success("FAQ updated successfully");
            }
        } else {
            res = await HttpClient.requestData("faq", "POST", data);
            if (res && res?.status) {
                toast.success("FAQ added successfully");
            }
        }

        if (res && res?.status) {
            setQues("");
            setAns("");
            navigate('/managefaq'); // Navigate back to the FAQ management page
        }
    };

    return (
        <div className='faqFormContainer' style={{ position: 'relative' }}>
            <div className='header'>
                <b style={{ fontSize: "20px", fontWeight: "400" }}>{isEdit ? 'Edit Faq' : 'Add Faq'}</b>
                <b className='back' onClick={handleBackClick} style={{ color: "rgb(208, 38, 38)" }}>
                    <i className="fas fa-arrow-left" style={{ marginRight: '8px' }}></i>
                    Back
                </b>
            </div>
            <div className='addFaq'>
                <b>{isEdit ? 'EDIT FAQ' : 'ADD FAQ'}</b>
            </div>
            <form className='faqForm'>
                <div className='formGroup'>
                    <label htmlFor="question">Question</label><br />
                    <input type="text" id="question" placeholder="Question" value={ques} onChange={(e) => setQues(e.target.value)} />
                </div>
                <div className='formGroup'>
                    <label htmlFor="answer">Answer</label><br />
                    <textarea id="answer" placeholder="Answer" value={ans} onChange={(e) => setAns(e.target.value)}></textarea>
                </div>
                <button type="submit" className='saveButton' style={{ backgroundColor: "rgb(208, 38, 38)" }} onClick={handleSubmit}>
                    {isEdit ? 'Update' : 'Save'}
                </button>
            </form>

            <footer style={{ position: "fixed", bottom: "0", width: "100%", textAlign: "", padding: "10px 0" }}>
                <p style={{ fontSize: "12px", color: "#666" }}>Copyright © 2024 Psedge. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default ManageFaqForm;
